

import { Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Tarjeta_Portada_Blogs = ({ titulo, parrafo, imagen }) => {
    const theme = useTheme();
    const esMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ px: 0 }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                sx={{ maxWidth: '1400px' }}
            >
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                >
                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        {/* TÍTULO PRINCIPAL COMO H1 */}
                        <Typography
                            variant="h1"
                            component="h1"
                            sx={{  pb: 4 }}
                        >
                            {titulo}
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        justifyContent="flex-start"
                        alignItems="center"
                    >
                        {/* PÁRRAFO COMO P */}
                        <Typography
                            variant="body1"
                            component="p"
                            sx={{  }}
                        >
                            {parrafo}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Portada_Blogs;
